import React, { useContext, useState } from 'react';
import { useStyletron } from 'baseui';
import { EMPTY_OBJECT, FormBuilder, AppContext, ModalContext } from 'commons-ui';

import useService from '../../../useService';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from '../../../utils/formConfig';
import { BUTTON_LABELS } from '../../constants';

interface IProps {
	setKeyData: (value: string) => void;
}

const ViewDobContent: React.FC<IProps> = ({ setKeyData }) => {
	const [css] = useStyletron();
	const { showAlert } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);
	const { viewDobDetails } = useService();
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const handleFormSubmit = async (formData: { ticketId: string; description: string }) => {
		try {
			setShowLoader(true);
			const result = await viewDobDetails({ ticketId: formData.ticketId, description: formData.description });
			if (!result || result.success === false || !result.data || !result.data.data) {
				showAlert('Failed to fetch DOB. Please check your permissions or try again.', { type: 'error' });
				return;
			}
			let dob: string = '-';
			if (result.data.data.dob) {
				dob = (result.data.data.dob as string) || '-';
			} else {
				showAlert('No DOB found.', { type: 'error' });
			}
			setKeyData(dob);
			setModalConfig({ isOpen: false });
		} catch (error) {
			showAlert('Failed to fetch DOB. Please try again.', { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return (
		<div className={css({ width: '40vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				setShowLoader={setShowLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{ submitLabel: BUTTON_LABELS.VIEW, discardLabel: BUTTON_LABELS.DISAGREE }}
				hidePopUp
			/>
		</div>
	);
};

export default ViewDobContent;
